import { Link } from "react-router-dom";
import { Container, Eyebrow, MaskedLines, Reveal } from "@/components/Motion";

export default function PageHero({ eyebrow, titleLines, sub, image }) {
  return (
    <section className="relative overflow-hidden bg-navy-950 pb-16 pt-36 sm:pb-20 sm:pt-44 grain">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-navy-950/70 via-navy-950/80 to-navy-950" />
        </>
      )}
      <div className="absolute inset-0 grid-lines-dark" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="absolute -top-24 right-0 h-96 w-96 rounded-full bg-blue-600/20 blur-[120px]"
      />
      <Container className="relative">
        <Reveal>
          <Eyebrow dark>{eyebrow}</Eyebrow>
        </Reveal>
        <MaskedLines
          lines={titleLines}
          className="mt-6 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl"
        />
        {sub && (
          <Reveal delay={0.5}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">{sub}</p>
          </Reveal>
        )}
        <Reveal delay={0.6}>
          <nav aria-label="Breadcrumb" className="mt-8 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-500">
            <Link to="/" className="transition-colors hover:text-cyan-400" data-testid="breadcrumb-home">
              Home
            </Link>
            <span aria-hidden="true">/</span>
            <span className="text-cyan-400">{typeof eyebrow === "string" ? eyebrow : "Page"}</span>
          </nav>
        </Reveal>
      </Container>
    </section>
  );
}
